import React from 'react';
import './AboutPage.css';

function AboutPage() {
  return (
    <div className="about-page">
      {/* Hero Section */}
      <section className="about-hero">
        <div className="container">
          <div className="hero-content">
            <h1 className="hero-title">Who We Are?</h1>
            <div className="hero-description">
              <p>With over decades of expertise,</p>
              <p>Elite International Sports is a major player in the field</p>
              <p>of indoor and outdoor sports infrastructure.</p>
              <p>We specialize in high-performance sports surfaces.</p>
            </div>
          </div>
        </div>
      </section>

      {/* Sports Facilities Showcase */}
      <section className="facilities-showcase">
        <div className="container">
          <div className="facilities-grid">
            <div className="facility-item">
              <div className="facility-image basketball-court">
                <div className="facility-overlay">
                  <h4 className="facility-name">Basketball Courts</h4>
                </div>
              </div>
            </div>
            <div className="facility-item">
              <div className="facility-image tennis-court">
                <div className="facility-overlay">
                  <h4 className="facility-name">Tennis Courts</h4>
                </div>
              </div>
            </div>
            <div className="facility-item">
              <div className="facility-image running-track">
                <div className="facility-overlay">
                  <h4 className="facility-name">Running Tracks</h4>
                </div>
              </div>
            </div>
            <div className="facility-item">
              <div className="facility-image football-field">
                <div className="facility-overlay">
                  <h4 className="facility-name">Football Fields</h4>
                </div>
              </div>
            </div>
            <div className="facility-item">
              <div className="facility-image volleyball-court">
                <div className="facility-overlay">
                  <h4 className="facility-name">Volleyball Courts</h4>
                </div>
              </div>
            </div>
            <div className="facility-item">
              <div className="facility-image badminton-court">
                <div className="facility-overlay">
                  <h4 className="facility-name">Badminton Courts</h4>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Expertise Section */}
      <section className="expertise-section">
        <div className="container">
          <div className="expertise-content">
            <div className="expertise-text">
              <h2 className="section-title">Our Expertise</h2>
              <div className="expertise-description">
                <p>With over decades of experience in sports infrastructure development, Elite International Sports has established itself as a leading provider of high-quality sports facilities.</p>
                <p>We specialize in creating world-class sports surfaces that meet international standards and provide optimal performance for athletes across all levels.</p>
                <p>Our team of experts combines technical knowledge with practical experience to deliver turnkey solutions for indoor and outdoor sports infrastructure.</p>
              </div>
              <div className="expertise-stats">
                <div className="stat-item">
                  <div className="stat-number">20+</div>
                  <div className="stat-label">Years Experience</div>
                </div>
                <div className="stat-item">
                  <div className="stat-number">500+</div>
                  <div className="stat-label">Projects Completed</div>
                </div>
                <div className="stat-item">
                  <div className="stat-number">50+</div>
                  <div className="stat-label">Sports Types</div>
                </div>
                <div className="stat-item">
                  <div className="stat-number">100%</div>
                  <div className="stat-label">Client Satisfaction</div>
                </div>
              </div>
            </div>
            <div className="expertise-image">
              <div className="image-placeholder">
                <div className="placeholder-content">
                  <h3>Sports Infrastructure Excellence</h3>
                  <p>Building the future of sports</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Mission Section */}
      <section className="mission-section">
        <div className="container">
          <div className="mission-content">
            <h2 className="section-title">Our Mission</h2>
            <div className="mission-grid">
              <div className="mission-item">
                <div className="mission-icon">🎯</div>
                <h3 className="mission-title">Excellence</h3>
                <p className="mission-description">Delivering world-class sports infrastructure that meets international standards and exceeds expectations.</p>
              </div>
              <div className="mission-item">
                <div className="mission-icon">🏗️</div>
                <h3 className="mission-title">Innovation</h3>
                <p className="mission-description">Utilizing cutting-edge technology and materials to create superior sports surfaces and facilities.</p>
              </div>
              <div className="mission-item">
                <div className="mission-icon">🤝</div>
                <h3 className="mission-title">Partnership</h3>
                <p className="mission-description">Building long-term relationships with clients through reliable service and exceptional results.</p>
              </div>
              <div className="mission-item">
                <div className="mission-icon">🏆</div>
                <h3 className="mission-title">Performance</h3>
                <p className="mission-description">Creating facilities that enhance athletic performance and provide optimal playing conditions.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer">
        <div className="footer-background"></div>
        <div className="container">
          <div className="footer-content">
            <div className="footer-column">
              <h3 className="footer-title">About Us</h3>
              <p className="footer-text">
                We are committed to excellence in sports training and community building. 
                Our comprehensive programs help athletes develop both physically and mentally.
              </p>
            </div>
            <div className="footer-column">
              <h3 className="footer-title">Latest Posts</h3>
              <div className="footer-post">
                <div className="post-date">
                  <span className="day">15</span>
                  <span className="month">Fri</span>
                </div>
                <div className="post-content">
                  <h4 className="post-title">New Training Program Launched</h4>
                  <p className="post-excerpt">Advanced coaching techniques for professional athletes</p>
                </div>
              </div>
              <div className="footer-post">
                <div className="post-date">
                  <span className="day">04</span>
                  <span className="month">Fri</span>
                </div>
                <div className="post-content">
                  <h4 className="post-title">Championship Results Announced</h4>
                  <p className="post-excerpt">Outstanding performances in the latest tournament</p>
                </div>
              </div>
              <button className="view-more">View More...</button>
            </div>
            <div className="footer-column">
              <h3 className="footer-title">Quick Links</h3>
              <ul className="footer-links">
                <li><a href="/" className="footer-link">HOME</a></li>
                <li><a href="#" className="footer-link">ABOUT OUR WEBSITE</a></li>
                <li><a href="#" className="footer-link">SHOP</a></li>
                <li><a href="#" className="footer-link">GALLERY</a></li>
                <li><a href="/contact" className="footer-link">CONTACT</a></li>
              </ul>
            </div>
            <div className="footer-column">
              <h3 className="footer-title">Contact Details</h3>
              <div className="contact-info">
                <div className="contact-item">📍 123 Sports Avenue, Athletic District, City 12345</div>
                <div className="contact-item">📞 0123-456-789</div>
                <div className="contact-item">✉️ info@askmesportsalliance.com</div>
                <div className="contact-item">🌐 www.askmesportsalliance.com</div>
                <div className="contact-item">🕐 7AM - 8PM</div>
              </div>
            </div>
          </div>
          <div className="footer-logo">
            <img src="/assets/main logo.png" alt="Sports Alliance Logo" className="footer-logo-icon" />
            <span className="footer-logo-text">ELITE INTERNATIONAL SPORTS</span>
          </div>
          <div className="footer-social">
            <span className="social-icon">f</span>
            <span className="social-icon">t</span>
            <span className="social-icon">in</span>
            <span className="social-icon">G+</span>
          </div>
          <div className="footer-copyright">
            Copyright © 2023 Elite International Sports. Building Future, Shaping Champions.
          </div>
        </div>
      </footer>
    </div>
  );
}

export default AboutPage;